import { Attachment } from 'src/app/front-user/shared/models/attachment.model';
import { GenericLookup } from 'src/app/front-user/shared/models/generic-lookup.model';
import { BaseRequest } from 'src/app/shared/models/base-request.model';

export class FeesEstimate {
    Id: string;
    RequestorId: string;
    VesselName: string;
    SCID: string;
    IMONO: string;
    CallSign: string;
    ShipTypeId: number;
    FuelTypeIds: string;
    FuelTypeOther: string;
    IMOCII: number;
    PropellerTypeId: number;
    IsScrubberInstalled: boolean;
    VesselTypeOther: string;
    ShipStatus: number;
    PassengersNumber: number;
    ShipmentTypeId: number;
    ShipmentQuantity: number
    IsMilitaryShip: boolean;
    MilitaryShipmentTypeId: number;
    MilitaryShipmentQuantity: number;
    IsRoofFloatingUnits: boolean;
    TotalSuezAmount: number;
    FloatingUnitHeight: number;
    FloatingUnitWidth: number;
    FloatingUnitLength: number;
    IsEmptyConatiners: boolean;
    FloorsNumber: number;
    IsRoofContainers: boolean;
    RoofContainerFloorsNumber: string;
    IsGasShip: boolean;
    GasType: string;
    GazAmount: string;
    ShipNationalityId: number;
    Height: number;
    Width: number;
    TotalSuezCanalAmout: number;
    SuezCanalNetTonnage: number;
    ArrivalDate: Date;
    AccessCapacity: number;
    TransitDate: Date;
    LastTransitDate: Date;
    GraveMaterial: string;
    SubmersibleAccess: string;
    Flake: string;
    Scouts: string;
    ComingFrom: string;
    MarineRequirements: string
    DestinedTo: string;
    ValidFor: number;
    ReceiverUserName: string;
    SelectedCurrencyId: number;
    Currency: GenericLookup = new GenericLookup();
    Attachments: Attachment[] = [];
    InsuranceValue: number;
    FeeValue: number;
    TotalFees: number;
    StatusId: number;
    ExpirationDate: Date;
    ShipmentOther: string;
    MilitaryShipmentOther: string;
    MeasurementDescription: string;
    DirectionId: number;
    ContainerReduction: string;
    PrincipalName: string;
    PrincipalEMail: string;
    PrincipalFax: string;
}